import { AdditionalServicePlanFormModel } from './form.model';

export const additionalServicePlanInitialValues: AdditionalServicePlanFormModel = {
  isQuoteValid: false,
  paymentType: 'monthly',
  contractDuration: '',
  firstRegistrationDate: '',
  payment: null,
  paymentTerm: '',
  recordedKilometers: null,
  servicePlanName: '',
};
